<template>
  <el-dialog
      :title="'查看'+chioseYear+'年度收费情况'"
      :visible.sync="situationDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="1200px"
      center>
    <el-form :model="situationForm" ref="situationForm" label-width="150px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="社区：" prop="project">
            <el-input :value="project" readonly placeholder="请输入社区"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="小区：" prop="community">
            <el-input :value="community" readonly placeholder="请输入小区"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="楼门户：" prop="room">
            <el-input :value="room" readonly placeholder="请输入楼门户"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="户主姓名：" prop="name">
            <el-input :value="name" readonly placeholder="请在居民数据中修改"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="收费年度：" prop="year">
            <el-input :value="chioseYear + '年度'" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="应收物业费：" prop="YJWuYeFei">
            <el-input v-model="situationForm.YJWuYeFei" type="number" readonly placeholder="请输入应收物业费"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收物业费：" prop="SjWuYeFei">
            <el-input v-model="situationForm.SjWuYeFei" type="number" readonly placeholder="请输入实收物业费"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="应收保安费：" prop="YJBaoAnFei">
            <el-input v-model="situationForm.YJBaoAnFei" type="number"  placeholder="请输入应收保安费"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收保安费：" prop="SjBaoAnFei">
            <el-input v-model="situationForm.SjBaoAnFei" type="number" readonly placeholder="请输入实收保安费"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="应收卫生费：" prop="YJWeiShengFei">
            <el-input v-model="situationForm.YJWeiShengFei" type="number" readonly placeholder="请输入应收物业费"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收卫生费：" prop="SjweishengFei">
            <el-input v-model="situationForm.SjweishengFei" type="number" readonly placeholder="请输入实收物业费"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="应收停车管理费：" prop="YJTingCheGuanLiFei">
            <el-input v-model="situationForm.YJTingCheGuanLiFei" type="number" readonly placeholder="请输入应收物业费"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收停车管理费：" prop="SjTingCheGuanLiFei">
            <el-input v-model="situationForm.SjTingCheGuanLiFei" type="number" readonly placeholder="请输入实收物业费"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="应收垃圾清运费：" prop="YJLaJiQingYunFei">
            <el-input v-model="situationForm.YJLaJiQingYunFei" type="number" readonly placeholder="请输入应收物业费"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收垃圾清运费：" prop="SjLaJiQingYunFei">
            <el-input v-model="situationForm.SjLaJiQingYunFei" type="number" readonly placeholder="请输入实收物业费"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-for="(item,index) in situationForm.otherDeiYong" :key="index">
        <el-col :span="12">
          <el-form-item :label="'应收' + item.name + ':'" prop="yinjiao">
            <el-input v-model="item.yinjiao" type="number" readonly :placeholder="'请输入'+item.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'实收' + item.name + ':'" prop="shijiao">
            <el-input v-model="item.shijiao" type="number" readonly :placeholder="'请输入'+item.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-table
          :data="situationYearList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          border
          style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="收费年度" prop="nian"></el-table-column>
        <el-table-column label="应收物业费" prop="yj_wuyefei"></el-table-column>
        <el-table-column label="实收物业费" prop="sj_wuyefei"></el-table-column>
        <el-table-column label="收费状态" prop="username">
          <template slot-scope="scope">
            <div>
              <span style="color: green"   v-if="Number(scope.row.sj_wuyefei)">已收费</span>
              <span style="color: #d00000" v-else>未收费</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                  size="small"
                  type="primary"
                  @click="getCargeOfyear(scope.row.nian)"
              >查看
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>


      <el-form-item class="flex align-center justify-around margin-top" label-width="0">
        <el-button class="padding-lr-xl" type="primary" @click="resetForm('situationForm')">关闭</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {optionList, year} from "@/utils/utils";
import {wuYeQingKuangShow,liNianWuYeQingKuangList} from "@/api/property";

export default {
  name: "situationDetail",
  props: {
    situationDetail: {
      type: Boolean,
      default: false
    },
    year: {
      type: Number,
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {
    return {
      chioseYear:'',
      yearList: optionList(true, year),
      project: '',
      community: '',
      room: '',
      name: '',
      situationForm: {
        YJWuYeFei: '',
        SjWuYeFei: '',
        YJBaoAnFei: '',
        SjBaoAnFei: '',
        YJWeiShengFei: '',
        SjweishengFei: '',
        YJTingCheGuanLiFei: '',
        SjTingCheGuanLiFei: '',
        YJLaJiQingYunFei: '',
        SjLaJiQingYunFei: '',
        otherDeiYong: []
      },
      situationYearList:[]
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    //  查询某年的收费内容
    async getCargeOfyear(val) {
      this.chioseYear = val
      let _data = await wuYeQingKuangShow(this.setId, val)
      this.situationForm = {
        YJWuYeFei: _data.data.yj_wuyefei,
        SjWuYeFei: _data.data.sj_wuyefei,
        YJBaoAnFei: _data.data.yj_baoanfei,
        SjBaoAnFei: _data.data.sj_baoanfei,
        YJWeiShengFei: _data.data.yj_weishengfei,
        SjweishengFei: _data.data.sj_weishengfei,
        YJTingCheGuanLiFei: _data.data.yj_tingcheguanlifei,
        SjTingCheGuanLiFei: _data.data.sj_tingcheguanlifei,
        YJLaJiQingYunFei: _data.data.yj_lajiqingyunfei,
        SjLaJiQingYunFei: _data.data.sj_lajiqingyunfei,
        otherDeiYong: _data.data.other_feiyong ? JSON.parse(_data.data.other_feiyong) : []
      }
    },
    //  获取收费内容
    async getCarge() {
      let _data = await wuYeQingKuangShow(this.setId, this.year)
      this.situationForm = {
        YJWuYeFei: _data.data.yj_wuyefei,
        SjWuYeFei: _data.data.sj_wuyefei,
        YJBaoAnFei: _data.data.yj_baoanfei,
        SjBaoAnFei: _data.data.sj_baoanfei,
        YJWeiShengFei: _data.data.yj_weishengfei,
        SjweishengFei: _data.data.sj_weishengfei,
        YJTingCheGuanLiFei: _data.data.yj_tingcheguanlifei,
        SjTingCheGuanLiFei: _data.data.sj_tingcheguanlifei,
        YJLaJiQingYunFei: _data.data.yj_lajiqingyunfei,
        SjLaJiQingYunFei: _data.data.sj_lajiqingyunfei,
        otherDeiYong: _data.data.other_feiyong ? JSON.parse(_data.data.other_feiyong) : []
      }
    },
    //  获取历年物业缴费情况列表
    async getYearList(){
      let _data = await liNianWuYeQingKuangList(this.setId)
      this.situationYearList = _data.data
    }
  },
  watch: {
    setItem() {
      this.project = this.setItem.xiangmu_name
      this.community = this.setItem.xiaoqu_name
      this.room = this.setItem.building_name + '-' + this.setItem.element_name + '-' + this.setItem.room_name
      this.name = this.setItem.huzu_name
    },
    situationDetail() {
      if (this.situationDetail) {
        this.getCarge()
        this.getYearList()
        this.chioseYear = this.year
      }
    },
  }
}
</script>

<style scoped lang="scss">

</style>
